import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss']
})
export class FilterPanelComponent {
  @Input() title = 'Filtros';
  @Input() expanded = true;

  @Output() expandedChange = new EventEmitter<boolean>();
  @Output() search = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();

  toggle(): void {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }

  onSearch(event: Event): void {
    event.preventDefault();
    this.search.emit();
  }

  onClear(): void {
    this.clear.emit();
  }
}
